import React from "react";
import { Formik } from "formik";

class FormComponent extends React.Component {

    static defaultProps = {
        initialValues: null,
        validateFunc: null,
        submitFunc: null,
        bulkCheckboxControls: false,
        inputs: [{ key: 'name', type: 'text', inputType: 'input', placeholder: 'name', label: 'name', options: null, disabled: false }]
    };

    renderInputs = (values, errors, touched, handleChange, handleBlur) => {
        let { inputs } = this.props;

        return (
            <div>
                {
                    inputs.map(element => {
                        return (
                            <div className="form-group"
                                key={element.inputType === 'radio' ? element.label : element.key}>
                                {this.getInput(element, values, errors, touched, handleChange, handleBlur)}
                            </div>
                        );
                    })
                }
            </div>
        );
    };

    getInput = (element, values, errors, touched, handleChange, handleBlur) => {
        if (element.inputType === 'checkbox') {
            return (
                <div>
                    {/* <div className="custom-control custom-checkbox">
                        <input type="checkbox" className="custom-control-input" id="customCheck1" />
                        <label className="custom-control-label" for="customCheck1">Check this custom checkbox</label>
                        {errors[element.key] && touched[element.key] && <label className="text-danger p-2">{errors[element.key]}</label>}
                    </div> */}
                    <div className="custom-control custom-checkbox">
                        <input type={"checkbox"} className="form-check-input" id={element.key}
                            placeholder={element.placeholder}
                            name={element.key}
                            onChange={handleChange} onBlur={handleBlur}
                            value={element.value}
                            disabled={element.disabled}
                            checked={values && values[element.key] ? values[element.key] : false}
                        />
                        <label className="form-check-label text-dark m-1" htmlFor={element.key}>{element.label}</label>
                        {errors[element.key] && touched[element.key] && <label className="text-danger p-2">{errors[element.key]}</label>}
                    </div>
                </div>
            );
        } else if (element.inputType === 'radio') {
            return (
                <div>
                    <input type={element.type} className="form-check-input" id={element.label}
                        placeholder={element.placeholder}
                        name={element.key}
                        onChange={handleChange} onBlur={handleBlur}
                        value={element.value}
                        disabled={element.disabled} />
                    <label className="form-check-label text-dark h5" htmlFor="Name">{element.label}</label>
                    {errors[element.key] && touched[element.key] && <label className="text-danger p-2">{errors[element.key]}</label>}
                </div>
            );
        } else if (element.inputType === 'select') {
            return (
                <div>
                    <label className="text-dark h5" htmlFor={element.key}>{element.label}</label>
                    <select
                        name={element.key}
                        value={(values && values[element.key]) ? values[element.key] : ''}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        id={element.key}
                        disabled={element.disabled}
                        className="form-control custom-select"
                    >
                        {(!!element.placeholder) ? <option value={'null'} label={element.placeholder} /> : null}
                        {/* {element.options.map( (option, index) => {
                            return ( <option value={option.value} label={option.label} key={ option.value ? option.value : index}/> )
                        })} */}
                        {element.options.map((option, index) => {
                            return (<option value={option.value} label={option.label} key={index ? index : option.value} />)
                        })}
                    </select>
                    {errors[element.key] && touched[element.key] && <label className="text-danger p-2">{errors[element.key]}</label>}
                </div>);
        } else {
            let inputclass = element.fixedPre || element.fixedPost ? 'input-group' : '';
            return (
                <div >
                    <label className="text-dark h5" htmlFor={element.key}>{element.label}</label>
                    <div id={element.key} className={inputclass}>
                        {!!element.fixedPre && <span className='input-group-text'> {element.fixedPre} </span>}
                        <input type={element.type} className="form-control"
                            placeholder={element.placeholder}
                            name={element.key}
                            onChange={handleChange} onBlur={handleBlur}
                            value={values && values[element.key] ? values[element.key] : ''}
                            disabled={element.disabled} 
                            required={element.required}/>
                        {!!element.fixedPost && <span className='input-group-text'> {element.fixedPost} </span>}
                    </div>
                    {errors[element.key] && touched[element.key] && <label className="text-danger p-2">{errors[element.key]}</label>}
                </div>
            );
        }

    };

    renderBulkCheckboxControls = (values, setValues) => {
        if (!this.props.bulkCheckboxControls) {
            return null;
        }

        const checkboxInputs = this.props.inputs.filter((input) => input.inputType === 'checkbox');
        const setAllCheckboxes = (checked) => {
            const nextValues = { ...values };
            checkboxInputs.forEach((input) => {
                nextValues[input.key] = checked;
            });
            setValues(nextValues);
        };

        return (
            <div className="mb-3">
                <button type="button" className="btn btn-outline-primary mr-2"
                    onClick={() => setAllCheckboxes(true)}>Select all</button>
                <button type="button" className="btn btn-outline-secondary"
                    onClick={() => setAllCheckboxes(false)}>Unselect all</button>
            </div>
        );
    };

    render() {
        let { initialValues, validateFunc, submitFunc } = this.props;

        return (
            <div>
                <Formik
                    initialValues={initialValues}
                    validate={validateFunc}
                    onSubmit={submitFunc}
                >
                    {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setValues }) => (
                        <form onSubmit={handleSubmit}>
                            {this.renderBulkCheckboxControls(values, setValues)}
                            {this.renderInputs(values, errors, touched, handleChange, handleBlur)}
                            <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                                Submit
                            </button>
                        </form>
                    )}
                </Formik>
            </div>
        );
    }
}

export default FormComponent;
